export default {
  title: 'Perfil',
  fields: {
    name: {
      label: 'Nome',
      placeholder: 'Introduza o nome do restaurante',
    },
    short_name: {
      label: 'Nome abreviado',
      placeholder: 'Introduza o nome abreviado do restaurante',
      tooltip:
        'Por vezes os nomes predefinidos dos restaurantes são muito longos e podem conter informação secundária, pelo que em alguns casos (ex.: notificações mais curtas) é necessária uma versão mais curta do nome',
    },
    phone_number: {
      label: 'Número de telefone',
      placeholder: 'Introduza o número de telefone do restaurante',
    },
    email: {
      label: 'Email',
      placeholder: 'Introduza o email do restaurante',
    },
    slug: {
      label: 'Slug',
      placeholder: 'Slug da marca',
    },
    language: {
      label: 'Idioma',
      placeholder: 'Usar o predefinido do grupo',
      tooltip:
        'O idioma que os clientes veem na loja online deste restaurante, e o predefinido para o seu pessoal. Deixe em branco para seguir o idioma da marca. O pessoal pode sempre escolher o seu próprio idioma para a sua vista.',
    },
    sms_name: {
      label: 'Nome SMS',
      placeholder: 'Nome de apresentação SMS',
    },
    instagram_link: {
      label: 'Link do Instagram',
      placeholder: 'Introduza o link do Instagram do restaurante',
    },
    website_link: {
      label: 'Link do website',
      placeholder: 'Introduza o link do website do restaurante',
    },
    impressum_link: {
      label: 'Link do Impressum',
      placeholder: 'Introduza o link do Impressum do restaurante',
    },
    timezone: {
      label: 'Fuso horário',
      placeholder: 'Pesquisar cidade ou fuso horário',
      tooltip:
        'O fuso horário em que este restaurante opera. Define os carimbos de hora dos pedidos, os horários de abertura e os slots de pedidos agendados. Foi definido a partir da morada do restaurante aquando da sua criação — corrija-o aqui se estiver errado.',
    },
    time_format: {
      label: 'Formato de hora',
      placeholder: 'Usar o padrão do país',
      tooltip:
        'Como os horários são mostrados à sua equipa, no painel e no portal de encomendas. Deixe em branco para seguir a convenção da região do restaurante.',
      options: {
        '12h': '12 horas (5:30 pm)',
        '24h': '24 horas (17:30)',
      },
    },
    primary_color: {
      label: 'Cor principal',
    },
    restaurant_type: {
      label: 'Tipo de restaurante e modelo de serviço',
    },
    cuisine_types: {
      label: 'Categorias de comida e tipos de cozinha',
    },
  },
  test_restaurant: {
    title: 'Restaurante de teste',
    description:
      'Torne este o seu restaurante de teste para experimentar impressão, e-mails, encomendas e integrações em produção. Continua a funcionar como qualquer outro restaurante e nunca é faturado. Pode ter um restaurante de teste.',
    description_test:
      'Este é o seu restaurante de teste. Funciona como qualquer outro restaurante e nunca é faturado. Os e-mails e SMS dos clientes sobre as suas encomendas começam com [TEST].',
    mark: 'Marcar como restaurante de teste',
    remove: 'Remover designação de Teste',
    slot_taken: 'Já tem um restaurante de teste ({{name}}). Remova primeiro a designação de Teste do existente.',
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    info_updated: 'Definições atualizadas com sucesso',
  },
};
